import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { getEnvironmentKind, getEnvironmentTitlePrefix } from './environment-marker';

/**
 * Remplace le `Title` d'Angular pour marquer l'onglet hors production.
 *
 * Le préfixe est appliqué ici et pas dans `TitleService` parce que plusieurs
 * producteurs écrivent le titre : la `TitleStrategy` par défaut du Router (routes
 * déclarant `title:`), `TitleService` (notifications, clignotement) et quelques
 * composants qui concatènent leur propre libellé. Seul ce point est commun à tous.
 *
 * L'opération est idempotente : tout préfixe déjà présent dans la valeur reçue est
 * retiré avant d'être remis en tête, pour que les concaténations
 * `setTitle(getTitle() + ' | X')` ne l'empilent pas.
 */
@Injectable()
export class EnvironmentTitle extends Title {
    private readonly prefix = getEnvironmentTitlePrefix(getEnvironmentKind());

    constructor() {
        super(inject(DOCUMENT));
    }

    override setTitle(newTitle: string): void {
        if (!this.prefix) {
            super.setTitle(newTitle);
            return;
        }

        super.setTitle(`${this.prefix}${this.stripPrefix(newTitle ?? '')}`);
    }

    private stripPrefix(title: string): string {
        return title.split(this.prefix).join('').trimStart();
    }
}
